import { combineReducers, configureStore } from '@reduxjs/toolkit';
import storage from 'redux-persist/lib/storage';
import { persistReducer, persistStore } from 'redux-persist';
import headerSlice from '../features/common/headerSlice';
import modalSlice from '../features/common/modalSlice';
import rightDrawerSlice from '../features/common/rightDrawerSlice';
import feesSlice from '../features/fees/feesSlice';
import classSlice from '../features/classes/classSlice';
import Studentslice from '../features/Showstudent/studentSlice';
import scholarSlice from '../features/scholarship/scholarSlice';
import teacherSlice from '../features/teacher/teacherSlice';
import staffSlice from '../features/Staffcategory/staffSlice';
import StaffsSlice from '../features/AddStaffs/StaffsSlice';
import VoucherSlice from "../features/Vouchers/voucherSlice";

// Configuration for Redux Persist
const persistConfig = {
  key: 'root',
  version: 1,
  storage,
  whitelist: ['voucher', 'student'], // Specify the states you want to persist
};

// Combine reducers
const rootReducer = combineReducers({
  header: headerSlice,
  rightDrawer: rightDrawerSlice,
  modal: modalSlice,
  class: classSlice,
  student: Studentslice,
  fees: feesSlice,
  scholar: scholarSlice,
  teacher: teacherSlice,
  staff: staffSlice,
  addstaff: StaffsSlice,
  voucher: VoucherSlice,
});

// Create a persisted reducer
const persistedReducer = persistReducer(persistConfig, rootReducer);

// Configure the store with the persisted reducer
const store = configureStore({
  reducer: persistedReducer,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: false,
    }),
});

// Create a persistor
export const persistor = persistStore(store);

export default store;
